var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('footer',{staticClass:"footer o-footer"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"Agrii"}}),_c('p',[_vm._v("v"+_vm._s(_vm.version))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }